import { createSlice } from '@reduxjs/toolkit'

import { ASYNC_STATUS } from '@/libs/constants'

const wishlistDetailInitialStates = {
  isAddingWishlistToCart: false,
  isRemoving: false,
  ownerName: '',
  ownerId: '',
  wishlistName: '',
  items: {
    items: [],
  },
  totalProduct: 0,
}

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState: {
    overview: {
      items: [],
      pagination: {},
      updatedTime: new Date().toISOString(),
    },
    productDetail: {
      materialName: '',
      materialNumber: '',
      img: '',
      quantity: 1,
    },
    fetchWishlistsState: ASYNC_STATUS.IDLE,
    isDeletingWishlist: false,
    isAddModalVisible: false,
    wishlistDetails: {
      isLoading: false,
      ...wishlistDetailInitialStates,
    },
  },
  reducers: {
    showAddProductToWishlistModal(state) {
      state.isAddModalVisible = true
    },
    hideAddProductToWishlistModal(state) {
      state.isAddModalVisible = false
    },
    getWishlistOverview(state, _action) {
      state.fetchWishlistsState = ASYNC_STATUS.PENDING
    },
    getWishlistOverviewSuccess(state, action) {
      Object.assign(state.overview, action.payload)
      state.fetchWishlistsState = ASYNC_STATUS.IDLE
    },
    getWishlistOverviewFailed(state) {
      Object.assign(state.overview, {
        items: [],
        pagination: {},
      })
      state.fetchWishlistsState = ASYNC_STATUS.IDLE
    },
    sendProductDetail(state, { payload }) {
      state.productDetail.materialName = payload.materialName
      state.productDetail.materialNumber = payload.materialNumber
      state.productDetail.img = payload.img
    },
    clearProductDetail(state) {
      state.productDetail.materialName = ''
      state.productDetail.materialNumber = ''
      state.productDetail.img = ''
    },
    getWishlistDetails: (state) => {
      state.wishlistDetails.isLoading = true
    },
    getWishlistDetailsSuccess: (state, { payload }) => {
      state.wishlistDetails.isLoading = false
      state.wishlistDetails = { ...payload }
    },
    getWishlistDetailsFailed: (state) => {
      state.wishlistDetails.isLoading = false
      state.wishlistDetails = wishlistDetailInitialStates
    },
    removeWishlistProduct: (state) => {
      state.wishlistDetails.isRemoving = true
    },
    removeWishlistProductSuccess: (state, { payload }) => {
      state.wishlistDetails.isRemoving = false
      state.wishlistDetails.totalProduct = +(state.wishlistDetails.totalProduct - 1)
      state.wishlistDetails.items.items = state.wishlistDetails.items.items.filter(
        (item) => item?.materialNumber !== payload?.materialNumber,
      )
    },
    removeWishlistProductFailed: (state) => {
      state.wishlistDetails.isRemoving = false
    },
    updateProductQuantity: () => {},
    updateProductQuantitySucceed: (state, { payload }) => {
      const { materialNumber, quantity } = payload.productData

      const mappedWishlistItems = state.wishlistDetails.items.items.map((item) => {
        if (item.materialNumber === materialNumber) {
          return { ...item, quantity }
        }

        return item
      })

      state.wishlistDetails.items.items = mappedWishlistItems
    },
    updateWishlistSharing: (state, { payload }) => {
      if (payload?.site === 'overview') {
        const updateIndex = state?.overview?.items?.findIndex((item) =>
          item?.wishlistId === payload?.wishlistId
        )
        state.overview.items[updateIndex].wishlistName = payload?.wishlistName
        state.overview.items[updateIndex].collaboratorCount = payload?.collaboratorCount
      }
      if (payload?.site === 'detail') {
        state.wishlistDetails.wishlistName = payload?.wishlistName
      }
    },
    addAllProductsToCart: (state) => {
      state.wishlistDetails.isAddingWishlistToCart = true
    },
    addAllProductsToCartSuccess: (state) => {
      state.wishlistDetails.isAddingWishlistToCart = false
    },
    addAllProductsToCartFailed: (state) => {
      state.wishlistDetails.isAddingWishlistToCart = false
    },
    deleteWishlist: (state, _action) => {
      state.isDeletingWishlist = true
    },
    deleteWishlistSuccess: (state) => {
      state.isDeletingWishlist = false
      state.overview.updatedTime = new Date().toISOString()
    },
    deleteWishlistFailed: (state) => {
      state.isDeletingWishlist = false
    },
  },
})

export const {
  showAddProductToWishlistModal,
  hideAddProductToWishlistModal,
  getWishlistOverview,
  getWishlistOverviewSuccess,
  getWishlistOverviewFailed,
  sendProductDetail,
  clearProductDetail,
  getWishlistDetails,
  getWishlistDetailsSuccess,
  getWishlistDetailsFailed,
  removeWishlistProduct,
  removeWishlistProductFailed,
  removeWishlistProductSuccess,
  updateProductQuantity,
  updateProductQuantitySucceed,
  addAllProductsToCart,
  addAllProductsToCartSuccess,
  addAllProductsToCartFailed,
  deleteWishlist,
  deleteWishlistSuccess,
  deleteWishlistFailed,
  updateWishlistSharing,
} = wishlistSlice.actions

export default wishlistSlice.reducer
